'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushCartFooter = PushCartFooter;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _functional = require('../../../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function PushCartFooter(_ref) {
  var action = _ref.action,
      submitTo = _ref.submitTo,
      footerMessage = _ref.footerMessage,
      subtotal = _ref.subtotal;

  return _react2.default.createElement('div', { className: 'psh-Footer' }, _react2.default.createElement('p', { className: 'psh-Footer_Message' }, footerMessage), _react2.default.createElement('form', { className: 'psh-Footer_Form', action: action, method: 'POST' }, _react2.default.createElement('div', { className: 'psh-Footer_Price' }, _react2.default.createElement('p', { className: 'psh-Footer_Label' }, window.theme.strings.pushCart.subtotal), _react2.default.createElement('p', {
    id: 'cart-subtotal',
    className: 'psh-Footer_Subtotal',
    dangerouslySetInnerHTML: {
      __html: (0, _functional.formatMoney)(subtotal)
    }
  })), _react2.default.createElement('button', {
    id: 'checkout-button',
    className: 'psh-Footer_Button psh-Footer_Button-checkout btn-Secondary-invert',
    type: 'submit',
    name: submitTo
  }, window.theme.strings.pushCart.checkout), _react2.default.createElement('a', {
    className: 'psh-Footer_Button psh-Footer_Button-cart btn-Primary btn-Primary-light',
    href: '/cart'
  }, _react2.default.createElement('span', { className: 'btn-Primary_Text', 'data-text': 'View Bag' }, 'View Bag'))));
}

PushCartFooter.propTypes = {
  footerMessage: _propTypes2.default.string.isRequired,
  action: _propTypes2.default.string.isRequired,
  submitTo: _propTypes2.default.oneOf(['cart', 'checkout']),
  subtotal: _propTypes2.default.number.isRequired
};